export default `
  mutation($userId: String!) {
    getCredentials(userId: $userId) { 
      Username
      Password
      ProfileId
    }
  }
`;